import React, { useEffect, useState } from 'react';
import { FiX } from 'react-icons/fi';
import './NotificationPanel.css';

const PANEL_CLOSE_MS = 300;

export default function NotificationPanel({
    isOpen,
    onClose,
    notifications,
    loading,
    onMarkAsRead,
    onMarkAllAsRead,
    formatDate,
}) {
    const [render, setRender] = useState(false);
    const [closing, setClosing] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setRender(true);
            setClosing(false);
            return undefined;
        }

        if (!render) return undefined;

        setClosing(true);
        const timer = setTimeout(() => {
            setRender(false);
            setClosing(false);
        }, PANEL_CLOSE_MS);

        return () => clearTimeout(timer);
    }, [isOpen, render]);

    if (!render) return null;

    const hasUnread = notifications.some((n) => !n.read);
    const overlayClass = `notification-panel-overlay${closing ? ' notification-panel-overlay--closing' : ''}`;
    const panelClass = `notification-panel${closing ? ' notification-panel--closing' : ''}`;

    return (
        <>
            <div className={overlayClass} onClick={onClose} />
            <aside className={panelClass}>
                <header className="notification-panel-header">
                    <h2>Notificaciones</h2>
                    <button type="button" className="notification-panel-close" onClick={onClose} aria-label="Cerrar">
                        <FiX size={22} />
                    </button>
                </header>

                {hasUnread && (
                    <div className="notification-panel-actions">
                        <button type="button" onClick={onMarkAllAsRead}>
                            Marcar todas como leídas
                        </button>
                    </div>
                )}

                <div className="notification-panel-body">
                    {loading && <p className="notification-panel-empty">Cargando...</p>}
                    {!loading && notifications.length === 0 && (
                        <p className="notification-panel-empty">No hay notificaciones</p>
                    )}
                    {!loading && notifications.map((notification) => (
                        <article
                            key={notification.id}
                            className={`notification-item ${notification.read ? 'read' : 'unread'}`}
                            onClick={() => !notification.read && onMarkAsRead(notification.id)}
                            onKeyDown={(e) => {
                                if ((e.key === 'Enter' || e.key === ' ') && !notification.read) {
                                    onMarkAsRead(notification.id);
                                }
                            }}
                            role="button"
                            tabIndex={0}
                        >
                            <div className="notification-item-header">
                                <h3>{notification.title}</h3>
                                {!notification.read && <span className="notification-unread-dot" />}
                            </div>
                            <p className="notification-item-description">{notification.description}</p>
                            <div className="notification-item-meta">
                                <span>{notification.type === 'INDIVIDUAL' ? 'Individual' : 'General'}</span>
                                <span>{formatDate(notification.createdAt)}</span>
                            </div>
                        </article>
                    ))}
                </div>
            </aside>
        </>
    );
}
